import React, { useState,useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";


import marksentryapi from '../api/resultDeclarationRouter';
import loginapi from '../api/login';


import { APISERVERURL } from '../APIServerURL';


const ResultDeclarationForm = ({accessToken,setAccessToken,setRefreshFailed}) => {
  const [status, setStatus] = useState('pending');
  const [date, setDate] = useState(""); // State for storing date
  const [resultDataLoaded,setResultDataLoaded]=useState(false);
  

  const navigate = useNavigate();
  const { batch,session,semester} = useParams();

  const handleGoBack = () => {
    navigate('/resultdeclaration'); // Navigate to marksentry component
  };

  const handleStatusChange = async() => {
   
    try{       
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await marksentryapi.post('/upDateResultStateOfABatch',{session,batch,status,date,semester},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      //setStatus(response.data.status);
      //setDate(response.data.date);

      //setResultDataLoaded(true);
      //((prevStatus) => (prevStatus === "declared" ? "pending" : "declared"));
      //alert(response.data);
      await fetchAllFormFillupStudents();
      }
      catch(err)
      {
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          //alert(nat);
          setAccessToken(nat);
          setRefreshFailed(false);  
                  
         
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await marksentryapi.post('/upDateResultStateOfABatch',{session,batch,status,date,semester},{headers:{'Authorization':`Bearer ${nat}`}});   
                      //setStatus(response.data.status);
                      //setDate(response.data.date);
                      
                      //setResultDataLoaded(true);
                      //setStatus((prevStatus) => (prevStatus === "declared" ? "pending" : "declared"));
                      await fetchAllFormFillupStudents();
                  }
                  catch(err)
                  {
                    //alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            //alert('dd');
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
          }
  };

    const handleDateChange = async() => {
   
    try{       
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await marksentryapi.post('/upDateResultDateOfABatch',{session,batch,status,date,semester},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      //setStatus(response.data.status);
      //setDate(response.data.date);

      //setResultDataLoaded(true);
      //((prevStatus) => (prevStatus === "declared" ? "pending" : "declared"));
      //alert(response.data);
      await fetchAllFormFillupStudents();
      }
      catch(err)
      {
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          //alert(nat);
          setAccessToken(nat);
          setRefreshFailed(false);  
                  
         
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await marksentryapi.post('/upDateResultDateOfABatch',{session,batch,status,date,semester},{headers:{'Authorization':`Bearer ${nat}`}});   
                      //setStatus(response.data.status);
                      //setDate(response.data.date);
                      
                      //setResultDataLoaded(true);
                      //setStatus((prevStatus) => (prevStatus === "declared" ? "pending" : "declared"));
                      await fetchAllFormFillupStudents();
                  }
                  catch(err)
                  {
                    //alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            //alert('dd');
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
          }
  };
  
  const fetchAllFormFillupStudents=async ()=>{
      try{       
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await marksentryapi.post('/getResultDeclarationOfABatch',{session,batch,semester},{headers:{'Authorization':`Bearer ${accessToken}`}});  
        setStatus(response.data.status);
        setDate(response.data.date);

        setResultDataLoaded(true);
        //alert(response.data.status);
        }
        catch(err)
        {
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="admin")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await marksentryapi.post('/getResultDeclarationOfABatch',{session,batch,semester},{headers:{'Authorization':`Bearer ${nat}`}});   
                        setStatus(response.data.status);
                        setDate(response.data.date);
                        
                        setResultDataLoaded(true);
                    }
                    catch(err)
                    {
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              //setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
    }

  useEffect(()=>{
    fetchAllFormFillupStudents();
  },[]);

 

  function downloadFile(fname)
    {
      fetch(`${APISERVERURL}/pdf/${fname}`).then((response) => {
        response.blob().then((blob) => {
         
            // Creating new object of PDF file
            const fileURL =
                window.URL.createObjectURL(blob);
                 
            // Setting various property values
            let alink = document.createElement("a");
            alink.href = fileURL;
            alink.download = fname;
            alink.click();
            //setIsloading(false);
        });
      });
    }

  async function handleDownloadCSV(e)
    {
      e.preventDefault();
      try{
        const response= await marksentryapi.post('/getResultOfABatchCSV',{session,batch,semester},{headers:{'Authorization':`Bearer ${accessToken}`}});    
        alert(response.data);
        downloadFile(response.data);
      }
      catch(err)
      {
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);
          
          const nat=x['data']['accessToken'];
          setAccessToken(nat);
          try{       
            const response= await marksentryapi.post('/getResultOfABatchCSV',{session,batch,semester},{headers:{'Authorization':`Bearer ${nat}`}});    
            downloadFile(response.data);
           }
           catch(err)
           {
            alert('unusual error newposts.js');
           }
        }
        catch(err)
        {
          alert('failed');
        }

      }
    }

   

  return (
    <main className="w-full">
    <div className="flex flex-col items-center w-full">


    <div className="w-full bg-red-100 relative py-1 flex flex-col justify-center">
       {/* Absolute Positioned Button */}
       <button  onClick={handleGoBack}  className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs">
         BACK
       </button>

       {/* Heading */}
       <div className="w-full flex justify-center">
        <h1 className="text-2xl  text-gray-400 text-center">RESULT DECLARATION FORM</h1>
       </div>
       <p className="w-full text-center font-semibold text-xs">({batch},{session},{semester})</p>    
     </div>

    
    {resultDataLoaded && <div className="w-[98%] max-w-[1200px] flex flex-col items-center justify-center">
      
      <div className="flex items-center justify-start space-x-2 p-1 rounded-md w-[98%] max-w-[400px] mt-6">
        <input
          type="checkbox"
          id="declaredCheckbox"
          checked={status==='declared'}
          onChange={handleStatusChange}
          className="w-5 h-5 accent-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-offset-2 cursor-pointer"
        />
        <label
          htmlFor="declaredCheckbox"
          className="text-lg text-gray-700 cursor-pointer transition-colors duration-200 hover:text-blue-600"
        >
          Mark as declared
        </label>
      </div>

      <div className="flex flex-col space-y-2 w-[98%] max-w-[400px] mt-6">
        <label htmlFor="dateInput" className="text-lg text-gray-500  p-2">
          Result Declaration Date
        </label>
        <input
          type="date"
          id="dateInput"
          value={date}
          onChange={(e) => {
            //const formattedDate = formatDate(e.target.value);
            setDate(e.target.value);
          }}
          onBlur={(e) => {
            //alert(date);
            handleDateChange();
          }}
          className="px-2 py-4 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
        />
      </div>


      
        <div className="w-full flex flex-wrap justify-center items-center gap-3 font-semibold border-b text-center mt-6">
            <button 
              className="underline text-blue-600 hover:text-blue-800 cursor-pointer text-xl"
              onClick={handleDownloadCSV}
            >
              DOWNLOAD CSV
            </button>

        </div>
       


    </div>
   }
   {
   !resultDataLoaded && <div className="w-[98%] max-w-[1200px]">
    Please wait!
    </div>
    }
    </div>
    </main>
  );
};

export default ResultDeclarationForm;
